import {
  ExternalLink,
  PhoneIncoming,
  PhoneOutgoing,
  Voicemail,
} from "@aircall/react-icons";
import { useTranslation } from "react-i18next";

import { PickCallTypeProps } from "./SectionCallType.decl";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

import { buildCallTimelineLink } from "@/components/SectionTiming";
import { useCall } from "@/hooks/useCall/useCall";

function PickCallType({ value }: PickCallTypeProps) {
  const { t } = useTranslation();

  switch (value) {
    case "inbound":
      return (
        <div className="flex items-center gap-2">
          <PhoneIncoming className="size-4 text-primary" />
          <span className="text-sm font-medium">{t("inbound")}</span>
        </div>
      );

    case "outbound":
      return (
        <div className="flex items-center gap-2">
          <PhoneOutgoing className="size-4 text-info" />
          <span className="text-sm font-medium">{t("outbound")}</span>
        </div>
      );

    case "voicemail":
      return (
        <div className="flex items-center gap-2">
          <Voicemail className="size-4 text-warning" />
          <span className="text-sm font-medium">{t("voicemail")}</span>
        </div>
      );

    default:
      break;
  }
}

export function SectionCallType() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call?.type) {
    return null;
  }

  return (
    <Section data-test="call-type-section">
      <SectionHeader>
        <SectionTitle>{t("call_context.call_type")}</SectionTitle>
      </SectionHeader>
      <PickCallType value={call.type} />
      {call.direction === "outbound" && call.automaticCallbackCallId && (
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-muted-foreground">
            {t("call_context.callback_from")}
          </span>
          <a
            data-test="open-call-timeline-anchor"
            className="inline-flex items-center gap-[2px] text-sm font-medium text-primary hover:underline"
            target="_blank"
            href={buildCallTimelineLink(call.automaticCallbackCallId)}
            rel="noreferrer"
          >
            {t("call_context.callback_request")}
            <ExternalLink className="size-[18px]" />
          </a>
        </div>
      )}
    </Section>
  );
}
